import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { onNavigateEvent } from 'analytics/performance'
import { useMenuContext } from 'components/styled/menu/menu-context'
import { MenuButtonContent } from 'components/styled/menu/menu-item/menu-button-content'
import {
  BaseMenuButtonProps,
  BaseMenuItem,
  BaseMenuButtonStyle,
  BaseMenuButtonStyleProps,
} from './base-menu-button'

export interface MenuLinkProps extends BaseMenuButtonProps {
  to: string
}

export const StyledMenuLink = styled(Link)<BaseMenuButtonStyleProps>`
  ${BaseMenuButtonStyle};

  &:hover,
  &:active,
  &:focus,
  &:visited {
    outline: none;
  }
`

export const MenuLink = ({
  variant = 'basic',
  icon,
  svgIcon,
  text,
  closeMenuOnClick = true,
  textVariant = 'body',
  event,
  to,
  ...props
}: MenuLinkProps) => {
  const { onClose } = useMenuContext()

  const onButtonClick = () => {
    if (event) onNavigateEvent(event)

    if (closeMenuOnClick) {
      onClose?.()
    }
  }

  return (
    <BaseMenuItem {...props}>
      <StyledMenuLink
        $variant={variant}
        onClick={onButtonClick}
        title={typeof text === 'string' ? text : undefined}
        /* Link props */
        $isSelected={false}
        tabIndex={0}
        to={to}
      >
        <MenuButtonContent
          text={text}
          textVariant={textVariant}
          isSubMenu={false}
          icon={icon}
          svgIcon={svgIcon}
        />
      </StyledMenuLink>
    </BaseMenuItem>
  )
}
